import CodeWrapper from "@cardRendering/codeWrapper";
import { IFieldValueProps } from "fields/fieldType";
import { IFieldCode } from "fields/types/code";

export default function CodeValue({ value, field }: IFieldValueProps<IFieldCode>): JSX.Element {
  return <CodeWrapper lang={field.attributes?.lang}>{value}</CodeWrapper>;
}
